import { render, staticRenderFns } from "./StatisticsForMonth.vue?vue&type=template&id=9dca6610&scoped=true&"
import script from "./StatisticsForMonth.vue?vue&type=script&lang=js&"
export * from "./StatisticsForMonth.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsForMonth.vue?vue&type=style&index=0&id=9dca6610&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dca6610",
  null
  
)

export default component.exports